






import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Typeform extends Vue {
    @Prop({ required: true }) urlNl!: string;

    @Prop({ required: true }) urlEn!: string;

    @Prop({ required: true }) urlFr!: string;

    get lang() {
        // return the lang from the html tag
        return document.documentElement.lang;
    }
}
